import { render, staticRenderFns } from "./MailV2Settings.vue?vue&type=template&id=5c8d451d&scoped=true"
import script from "./MailV2Settings.vue?vue&type=script&lang=js"
export * from "./MailV2Settings.vue?vue&type=script&lang=js"
import style0 from "./MailV2Settings.vue?vue&type=style&index=0&id=5c8d451d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d451d",
  null
  
)

export default component.exports